import { FilterOption } from '@britishcouncil/react-admin';
import { useMemo } from 'react';

import { useGetRolesQuery } from 'store/dictionaries/rolesApi';

export function useRolesOptions(): FilterOption<number>[] {
  const { data } = useGetRolesQuery();

  const roles = useMemo(
    () =>
      data?.map((role) => ({
        text: role.name,
        value: role.id,
      })) ?? [],
    [data]
  );

  return roles;
}
